// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_2Zd7x","postText":"LHRLY","buttonWrapper":"_3cJvu"};


//////////////////
// WEBPACK FOOTER
// ./containers/stages/OwnerCheckStage/styles.scss
// module id = 740
// module chunks = 0